import { useEffect, useRef } from "react";
import hljs from "highlight.js/lib/core";
import markdown from "highlight.js/lib/languages/markdown";
import javascript from "highlight.js/lib/languages/javascript";
import python from "highlight.js/lib/languages/python";
import "highlight.js/styles/vs2015.css";

// Register languages
hljs.registerLanguage("markdown", markdown);
hljs.registerLanguage("javascript", javascript);
hljs.registerLanguage("python", python);

export type ICodeHiglightProps = {
  code: string;
  language?: "python" | "javascript" | "html" | "css";
  background?: boolean;
  style?: any;
};

const CodeHighlight = ({
  code,
  language = "python",
  background = false,
  style,
}: ICodeHiglightProps) => {
  const codeRef = useRef<HTMLElement | null>(null);

  useEffect(() => {
    if (codeRef.current) {
      codeRef.current.removeAttribute("data-highlighted");
      hljs.highlightElement(codeRef.current); // Re-highlight the code
    }
  }, [code, language]);

  return (
    <pre
      style={{
        background: "transparent",
        padding: 0,
        overflow: "auto",
        maxWidth: "100%",
      }}
    >
      <code
        ref={codeRef}
        className={`language-${language}`}
        style={{
          ...(!background ? { background: "transparent" } : {}),
          padding: ".4rem 1rem",
          fontSize: ".9rem",
          display: "block",
          whiteSpace: "pre-wrap",
          wordWrap: "break-word",
          ...style,
        }}
      >
        {code}
      </code>
    </pre>
  );
};

export default CodeHighlight;
